import { gql } from '@apollo/client';
import {
  sharedInvoiceInput,
  sharedInvoiceInputFields,
} from '../fragments/invoice-input';
import MoneyFields from '../fragments/money/money-fields';
import { MasterEntityExternalRiskStatusFields } from '../customers/fragment';
import { InvoiceStatusFields } from '../invoices/fragments';

export const AVAILABLE_FACTORING = gql`
  query availableFactoring(${sharedInvoiceInputFields}) {
    invoices(${sharedInvoiceInput}) {
      totalCount
      edges {
        cursor
        node {
          id
          folio
          dateIssued
          ...InvoiceStatusFields
          isForOrdering
          hasPaymentsEmitted
          amountWithIva {
            ... MoneyFields
          }
          dteType {
            id
            name
          }
          company {
            id
            masterEntity {
              id
              clientExternalRiskStatus{
                ...MasterEntityExternalRiskStatusFields
              }
            }
          }
          receiver {
            id
            name
            displayNationalIdentifier
            debtorExternalRiskStatus{
              ...MasterEntityExternalRiskStatusFields
            }
          }
          complianceStatus {
            debtorApproved
            withinAvailableDays
            hasPaymentComplement
            rugInscribed
            __typename
          }
          preoffer {
            id
            monthlyRate
            defaultRate
            preofferevaluationrequest {
              id
              status
            }
          }
          offer {
            id
          }
          operation {
            id
          }
          references {
            id
            folio
            amountWithIva {
              amount
              currency {
                code
                name
              }
            }
          }
          creditNotes @client {
            id
            folio
            amountWithIva {
              amount
              currency {
                code
                name
              }
            }
          }
          debitNotes @client {
            id
            folio
            amountWithIva {
              amount
              currency {
                code
                name
              }
            }
          }
          preofferSelectable @client
        }
      }
    }
  }
  ${MoneyFields}
  ${MasterEntityExternalRiskStatusFields}
  ${InvoiceStatusFields}
`;

export const AVAILABLE_FACTORING_DOCUMENTS = gql`
  query availableFactoringDocuments(${sharedInvoiceInputFields}) {
    invoices(${sharedInvoiceInput}) {
      totalCount
      edges {
        cursor
        node {
          id
          folio
          preofferSelectable @client
          documents {
            file {
              name
            }
            type {
              code
            }
          }
        }
      }
    }
  }
`;

export const OFFER_EVALUATION_RESOLUTION = gql`
  query offerEvaluationResolution($id: ID!) {
    invoice(invoiceId: $id) {
      id
      preoffer {
        preofferevaluationrequest {
          evaluationResolution {
          reviewOc
          reviewHes
          reviewPortalScreenshot
          hasReceptionAcknowledgment
        }
      }
    }
  }
}
`;
